<template>
  <div class="background-modal align-modal" id="outModal" onkeypress="onClick">
    <div class="content">
      <div class="header"> 
        <div id="header-row">
          <p id="header-title">Detalhes do contato</p>
          <i class="fas fa-times" id="close-button" @click="dismissModal"></i>
        </div>
      </div>
      <div class="body">
        <div id="img-container">
          <img src="/imgs/default-profile.png">
        </div>
        <div id="details-container">
          <div class="custom-input-group">
            <label for="name">Nome Contato</label>
            <input 
              type="text" 
              class="form-control" 
              name="name" 
              id="name" 
              v-model="updateData.name" 
              required 
              :disabled="disable">
          </div>

          <div class="custom-input-group">
            <label for="phone">Telefone</label>
            <vue-tel-input 
              id="vlTel1" 
              v-model="updateData.phone"
              :input-options="options"
              mode="international" 
              :disabled="disable"
              :default-country="getDefaultCountryCode"
              :country="updateData.countryCode"
            ></vue-tel-input>
          </div>
          <div class="custom-input-group">
            <label for="company_name">Curso</label>
            <input
              type="text"
              class="form-control"
              name="company_name"
              id="company_name"
              v-model="updateData.company_name"
              :disabled="disable">
          </div>
          <div class="custom-input-group">
            <label for="company_name">Turma</label>
            <input
              type="text"
              class="form-control"
              name="group"
              id="group"
              v-model="updateData.group"
              :disabled="disable">
          </div>
          <div class="custom-input-group">
            <label for="chave-unica">Matrícula (RA)</label>
            <input
              type="text"
              class="form-control"
              name="chave-unica"
              id="chave-unica"
              v-model="updateData.unique_key"
              :placeholder="placeholder"
              :disabled="disable"
            >
          </div>

          <div class="custom-input-group">
            <label for="contactConsultor">Consultor</label>
              <select class="form-control" name="contactConsultor" id="contactConsultor" v-model="updateData.consultor" style="flex: 1" :disabled="disable">
                  <option v-for="consultor in arrayConsultor" :value="consultor.extension_line">{{ consultor.name }}</option>
              </select>
          </div>

          <div class="custom-input-group">
            <label for="status_matricula">Status da Matrícula</label>
            <input
              type="text"
              class="form-control"
              name="status_matricula"
              id="status_matricula"
              v-model="updateData.status_matricula"
              :disabled="disable">
          </div>

          <div class="custom-input-group">
            <label for="responsavel_nome">Nome do Responsável</label>
            <input
              type="text"
              class="form-control"
              name="responsavel_nome"
              id="responsavel_nome"
              v-model="updateData.responsavel_nome"
              :disabled="disable">
          </div>

          <div class="custom-input-group">
            <label for="responsavel_email">E-mail do Responsável</label>
            <input
              type="email"
              class="form-control"
              name="responsavel_email"
              id="responsavel_email"
              v-model="updateData.responsavel_email"
              :disabled="disable">
          </div>

          <div class="custom-input-group">
            <label for="codigo_familia">Código da Família</label>
            <input
              type="text"
              class="form-control"
              name="codigo_familia"
              id="codigo_familia"
              v-model="updateData.codigo_familia"
              :disabled="disable">
          </div>

          <div class="custom-input-group">
            <label for="data_atualizacao">Data de Atualização</label>
            <input
              type="text"
              class="form-control"
              name="data_atualizacao"
              id="data_atualizacao"
              v-model="updateData.data_atualizacao"
              disabled>
          </div>
        </div>
        
      </div>
      <div class="modal-rodape">
        <div id="button-group">
          <button type="button" :hidden="disable"  @click="updateCl" class="btn btn-success cursor-pointer" id="btn-save"><i class="fa fa-save"></i>    Salvar</button>
          <button type="button" :hidden="disable"  @click="deleteCl" class="btn btn-danger cursor-pointer" id="btn-delete"><i class="fa fa-trash"></i>    Excluir</button>
          <button type="button" :hidden="!disable" @click="enableEdit" class="btn btn-info cursor-pointer" id="btn-edit"><i class="fa fa-edit"></i>    Editar</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios';
import { parsePhoneNumberFromString, format } from 'libphonenumber-js';

export default {
  props:{
      data:{
        type: Object
      }
  },
  data(){
    return {
      show: true,
      arquivos: [],
      disable: true,
      updateData:{
        name: this.data.name,
        phone: this.data.phone,
        unique_key: this.data.unique_key,
        company_name: this.data.company_name,
        consultor: this.data.consultor,
        group: this.data.group,
        status_matricula: this.data.status_matricula,
        responsavel_nome: this.data.responsavel_nome,
        responsavel_email: this.data.responsavel_email,
        codigo_familia: this.data.codigo_familia,
        data_atualizacao: this.data.data_atualizacao,
      },
      arrayConsultor: [],
      // placeholder: 'XX.XXX.XXX-XX',
      placeholder: 'Insira a matrícula (RA)',
      options: {
        placeholder: 'Insira o telefone',
        required: true
      }
    }
  },
  created() {
		this.loadFila();
	},
  mounted(){
    this.$el.addEventListener('click', this.onClick);
    document.addEventListener('keyup', this.onClick);
  },
  computed: {
    getDefaultCountryCode() {
      try {
        const formattedPhoneNumber = '+' + this.updateData.phone; // Adiciona o símbolo "+" na frente do número de telefone
        const phoneNumber = parsePhoneNumberFromString(formattedPhoneNumber);
        
        if (!phoneNumber) {
          return null;
        }
        
        this.updateData.countryCode = '+' + phoneNumber.countryCallingCode; // Armazena o código do país em "countryCode" 

        const countryCodes = {
        '+1': 'US',   // Estados Unidos
        '+7': 'ru',   // Rússia
        '+20': 'eg',  // Egito
        '+27': 'za',  // África do Sul
        '+30': 'gr',  // Grécia
        '+31': 'nl',  // Países Baixos
        '+32': 'be',  // Bélgica
        '+33': 'fr',  // França
        '+34': 'es',  // Espanha
        '+36': 'hu',  // Hungria
        '+39': 'it',  // Itália
        '+40': 'ro',  // Romênia
        '+41': 'ch',  // Suíça
        '+43': 'at',  // Áustria
        '+44': 'gb',  // Reino Unido
        '+45': 'dk',  // Dinamarca
        '+46': 'se',  // Suécia
        '+47': 'no',  // Noruega
        '+48': 'pl',  // Polônia
        '+49': 'de',  // Alemanha
        '+51': 'pe',  // Peru
        '+52': 'mx',  // México
        '+53': 'cu',  // Cuba
        '+54': 'ar',  // Argentina
        '+55': 'br',  // Brasil
        '+56': 'cl',  // Chile
        '+57': 'co',  // Colômbia
        '+58': 've',  // Venezuela
        '+60': 'my',  // Malásia
        '+61': 'au',  // Austrália
        '+62': 'id',  // Indonésia
        '+63': 'ph',  // Filipinas
        '+64': 'nz',  // Nova Zelândia
        '+65': 'sg',  // Singapura
        '+66': 'th',  // Tailândia
        '+81': 'jp',  // Japão
        '+82': 'kr',  // Coreia do Sul
        '+84': 'vn',  // Vietnã
        '+86': 'cn',  // China
        '+90': 'tr',  // Turquia
        '+91': 'in',  // Índia
        '+92': 'pk',  // Paquistão
        '+93': 'af',  // Afeganistão
        '+94': 'lk',  // Sri Lanka
        '+95': 'mm',  // Mianmar (Birmânia)
        '+98': 'ir',  // Irã
        // Adicione outros códigos de país conforme necessário
      };
        this.updateData.countryCode = countryCodes[this.updateData.countryCode];
        return this.updateData.countryCode;
      } catch (error) {
        console.log('Erro ao formatar o número de telefone:', error);
        return null;
      }
    }
  },
  methods:{
    loadFila(){
            axios.get('/queue-consultor').then(({ data }) => {
                let allOperators = [];

                // Juntar todos os operadores em uma única lista
                Object.keys(data).forEach(key => {
                    allOperators = allOperators.concat(data[key].operadores);
                });

                // Remover duplicatas baseadas em extension_line
                const uniqueOperators = allOperators.filter((operator, index, self) =>
                    index === self.findIndex((o) => (
                        o.extension_line === operator.extension_line
                    ))
                );

                // Atribuir o array final ao arrayConsultor
                this.arrayConsultor = uniqueOperators;
            });
    },
    // Mascara de CPF/CNPJ desativada: o campo passou a ser a Matricula (RA),
    // que pode conter letras e nao tem formato fixo.
    // handleInput() {
    //   const value = this.updateData.unique_key.replace(/\D/g, '').slice(0, 14);
    //
    //   if (value.length === 11) {
    //     this.placeholder = 'CPF';
    //     this.$set(this.updateData, 'unique_key', value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'));
    //   } else if (value.length === 14) {
    //     this.placeholder = 'CNPJ';
    //     this.$set(this.updateData, 'unique_key', value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'));
    //   }
    // },
    enableEdit(){
      this.disable = !this.disable;
    },
    dismissModal(){
      this.$emit('dismissModal');
    },
    deleteCl(){
      axios.post('/customer_base/destroy', {id: this.data.id}).then(data => {
        Swal.fire(
          'Registro Excluído',
          'Este cliente não faz mais parte de sua base',
          'success'
        ).then((confirm) => {
          this.dismissModal();
        });
      });
    },
    checkForm: function(){
        if (this.updateData.name == null || this.updateData.name == ''){
            Swal.fire({
                html: 'O campo "Nome" não foi preenchido!',
                type: "warning",
                showCloseButton: true,
                confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
            });
            return false;  
        }
        if (this.updateData.phone == null || this.updateData.phone == ''){
            Swal.fire({
                html: 'O campo "Telefone" não foi preenchido!',
                type: "warning",
                showCloseButton: true,
                confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
            });
            return false;  
        }else{
          return true;
        }
    },
    updateCl(){
      if(this.checkForm()){
        this.updateData.phone = this.updateData.phone.replace(/\D/g, "");
        // A Matricula (RA) e gravada como digitada; limpar os nao-digitos
        // apagaria as letras do RA
        // this.updateData.unique_key = this.updateData.unique_key ? this.updateData.unique_key.replace(/\D/g,'') : '';
        this.updateData.unique_key = this.updateData.unique_key ? this.updateData.unique_key.trim() : '';
        axios.post('/customer_base/save', {
          id: this.data.id,
          name: this.updateData.name,
          phone: this.updateData.phone,
          unique_key: this.updateData.unique_key,
          company_name: this.updateData.company_name,
          consultor: this.updateData.consultor,
          wallet_group: this.updateData.group,
          status_matricula: this.updateData.status_matricula,
          responsavel_nome: this.updateData.responsavel_nome,
          responsavel_email: this.updateData.responsavel_email,
          codigo_familia: this.updateData.codigo_familia
        }).then(data => {
          Swal.fire(
            'Atualização realizada',
            'Os dados deste cliente foram atualizados',
            'success'
          ).then((confirm) => {
            this.dismissModal();
          });
        });
      }
    },
  },

}
</script>

<style scoped>

.background-modal{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color:rgba(125,125,125, 0.5);
    /* Respiro para o modal nao encostar nas bordas da tela */
    padding: 1rem;
    box-sizing: border-box;
    /* Ultima linha de defesa em telas muito baixas */
    overflow-y: auto;
}

.align-modal{
  display:flex;
  align-items: center;
  justify-content: center;
}

#header-row{
  display: flex;
  justify-content: space-between;
  background-color: #1c869a;
  border-top: 3px solid #f38630;
}

#header-title{
  color: white;
  font-weight: bold;
  margin: 5px 20px;
  align-self: center;
}

#close-button{
  font-weight: bolder;
  background-color: white;
  color: #aa1a1a;
  cursor: pointer;
  border: 1px solid #aa1a1a;
  border-radius: 10px !important;
  padding: 8px;
  align-self: center;
  margin: 5px;
}

#close-button:hover{
  background-color: #aa1a1a;
  color: white;
  transition: 0.5s;
  border: 1px solid white;
}

.content{
  background-color: #fff;
  width: 35em;
  /* Nunca passa da largura nem da altura da tela */
  max-width: 100%;
  max-height: 90vh;
  border-radius: 15px;
  /* Cabecalho e rodape fixos, apenas o corpo rola */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

.header{
  flex: 0 0 auto;
}

.modal-rodape{
  flex: 0 0 auto;
  background-color: #fff;
  border-top: 1px solid #e4e9ea;
  border-radius: 0 0 15px 15px;
}

.body{
  display:flex;
  flex-flow: row wrap;
  justify-content: center;
  /* flex: 1 + min-height: 0 e o que permite o overflow funcionar aqui */
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.row {
  width: 100%;
}

.body img{
    border-radius: 50%;
    height: 7em;
    border: 5px solid #1c869a66;
}

#img-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px;
}

#details-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 10px;
  /* Deixa os campos acompanharem a largura do modal em telas estreitas */
  flex: 1 1 18em;
  min-width: 0;
}

.custom-input-group {
  padding: 10px;
  min-width: 0;
}

.custom-input-group input,
.custom-input-group select {
  max-width: 100%;
}

.custom-input-group label {
  align-self: center;
  font-weight: bold;
}

#btn-save {
  color: white;
  background-color: #034103;
  border: 3px solid white;
  border-radius: 10px !important;
}

#btn-save:hover {
  color: #034103;
  background-color: white;
  border: 3px solid #034103;
  border-radius: 10px !important;
  transition: 0.5s;
}

#btn-delete {
  color: white;
  background-color: #aa1a1a;
  border: 3px solid white;
  border-radius: 10px !important;
}

#btn-delete:hover {
  color: #aa1a1a;
  background-color: white;
  border: 3px solid #aa1a1a;
  border-radius: 10px !important;
  transition: 0.5s;
}

#btn-edit {
  color: white;
  background-color: #0e0e69;
  border: 3px solid white;
  border-radius: 10px !important;
}

#btn-edit:hover {
  color: #0e0e69;
  background-color: white;
  border: 3px solid #0e0e69;
  border-radius: 10px !important;
  transition: 0.5s;
}

#button-group {
  display: flex;
  justify-content: flex-end;
  margin: 10px 20px;
}

</style>